import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (24 / 24);
  const localHeight = size * (17.359 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 24 17.359">
      <path
        d="M2.7,13.167A14.446,14.446,0,0,1,.054,8.983a.875.875,0,0,1,0-.607A14.441,14.441,0,0,1,2.7,4.191,12.213,12.213,0,0,1,12,0a12.214,12.214,0,0,1,9.3,4.191,14.452,14.452,0,0,1,2.647,4.184.875.875,0,0,1,0,.607A14.457,14.457,0,0,1,21.3,13.167,12.214,12.214,0,0,1,12,17.359,12.213,12.213,0,0,1,2.7,13.167ZM1.8,8.683c.617,1.4,3.486,6.94,10.2,6.94,6.661,0,9.587-5.577,10.2-6.947-.617-1.4-3.486-6.94-10.2-6.94C5.339,1.736,2.413,7.313,1.8,8.683Zm4.748,0A5.456,5.456,0,1,1,12,14.176,5.483,5.483,0,0,1,6.544,8.679Zm1.723,0A3.733,3.733,0,1,0,12,4.918,3.751,3.751,0,0,0,8.267,8.679Z"
        transform="translate(0)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
